import {
  GetAppointmentPackageResult,
  PatchAppointmentPackagePayload,
  PostAppointmentPackagePayload,
} from "../../../apis/appointmentApi";
import { Tax } from "../../../apis/clientApi";
import { AppointmentPackageForm } from "./AppointmentPackageDrawer.types";

export const appointmentPackageFormDefault: Partial<AppointmentPackageForm> = {
  expirationForEachAppointmentCredit: 30,
};

const DAY_IN_SECONDS = 60 * 60 * 24;
export const convertToAppointmentPackageForm = (
  appointmentPackage: GetAppointmentPackageResult["data"],
  taxes: Tax[],
  duplicate?: boolean,
): AppointmentPackageForm => {
  const expirationForEachAppointmentCredit =
    appointmentPackage.expirationForEachAppointmentCredit / DAY_IN_SECONDS;
  const tax = taxes.find((item) => item.uuid === appointmentPackage.taxId);
  const name = duplicate
    ? `${appointmentPackage.name} copy`
    : appointmentPackage.name;
  return {
    name,
    appointmentType: appointmentPackage.appointmentType,
    numberOfSessions: Number(appointmentPackage.numberOfSessions),
    expirationForEachAppointmentCredit,
    packagePrice: appointmentPackage.packagePrice,
    tax,
    discount: appointmentPackage.discount,
    availableOnMemberApp: appointmentPackage.availableOnMemberApp,
    description: appointmentPackage.description,
    longDescription: appointmentPackage.longDescription,
  };
};

export const convertToAppointmentPostPackagePayload = (
  values: AppointmentPackageForm,
): PostAppointmentPackagePayload => {
  const isFree = values.packagePrice === 0;
  const isRecurring = false;
  return {
    isFree,
    isRecurring,
    name: values.name,
    description: values.description,
    longDescription: values.longDescription,
    appointmentType: values.appointmentType.uuid,
    numberOfSessions: values.numberOfSessions,
    expirationForEachAppointmentCredit:
      values.expirationForEachAppointmentCredit * DAY_IN_SECONDS,
    availableOnMemberApp: values.availableOnMemberApp,
    packagePrice: values.packagePrice,
    hasTax: !!values.tax,
    taxId: isFree ? "None" : values.tax?.uuid || "None",
    taxPrice: isFree ? 0 : values.tax?.rate,
    taxName: isFree ? "None" : values.tax?.name || "None",
    discount: isFree ? undefined : values.discount?.uuid || undefined,
    staffPay: 0,
    staffPayType: "PERCENTAGE",
  };
};

export const convertToAppointmentPatchPackagePayload = (
  values: AppointmentPackageForm,
): PatchAppointmentPackagePayload => {
  const isFree = values.packagePrice === 0;
  const isRecurring = false;
  return {
    isFree,
    isRecurring,
    name: values.name,
    description: values.description,
    longDescription: values.longDescription,
    appointmentType: values.appointmentType.uuid,
    numberOfSessions: values.numberOfSessions,
    expirationForEachAppointmentCredit:
      values.expirationForEachAppointmentCredit * DAY_IN_SECONDS,
    availableOnMemberApp: values.availableOnMemberApp,
    packagePrice: values.packagePrice,
    hasTax: !!values.tax,
    taxId: isFree ? "None" : values.tax?.uuid || "None",
    taxPrice: isFree ? 0 : values.tax?.rate,
    taxName: isFree ? "None" : values.tax?.name || "None",
    discount: isFree ? "" : values.discount?.uuid || "",
    staffPay: 0,
    staffPayType: "PERCENTAGE",
  };
};
